import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message_container" }
const _hoisted_2 = {
  key: 0,
  class: "details_container"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sub_text" }
const _hoisted_5 = {
  key: 0,
  class: "image_container"
}
const _hoisted_6 = ["src"]

import { ref } from 'vue'
import CustomHeader from '../components/common/customHeader.vue'
import { useUserStore } from '@/stores/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'messageContentView',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const userStore = useUserStore()

const backNavigate = () => {
    show.value = false
    userStore.resetReadMessage()
}
const open = () => {
  show.value = true
}
__expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: { height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: _ctx.$t('message.messageContent'),
          "is-popup-close-back-icon": true,
          onClosePopup: backNavigate,
          "bg-color": '#024A49'
        }, null, 8, ["text"]),
        (_unref(userStore).readMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_unref(userStore).readMessage.title || '')), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userStore).readMessage.content), 1),
              (_unref(userStore).readMessage.attachment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _unref(userStore).readMessage.attachment
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})